import { NoticeCriteriaGroupActivity } from '../../../../../../api/enumerations';
import { TypologyAndCriteriaData } from '../../../../../../api/theHive/criteriaGroups/types';
import {
  BillingUnit,
  ReportType,
  TypologyCategory,
  TypologypropertyType,
  TypologyPriceType,
  TypologyRuleKeyword,
} from '../../../../../../api/theHive/typology/enumerations';

export interface TypologyGroupGridProps {
  isLoading: boolean;
  criteriasGroup: TypologyAndCriteriaData[];
  fetchTypologyGroups: () => Promise<void>;
}

export interface ITypologyModalProps {
  fetchTypologyGroups: () => Promise<void>;
}

// Pseudo-limite de UI: "Todos os tamanhos" → no payload vira
// rule_keyword=over + rule_first_value=1 (handoff §3.6).
export const ALL_SIZES = 'all_sizes';
export type TypologyRange = TypologyRuleKeyword | typeof ALL_SIZES;

// TIPO (typology) — tipo de serviço dentro de um serviço.
export interface Typology {
  id: number;
  type: TypologypropertyType;
  range: TypologyRange;
  area: string;
  area2?: string;
  visible: boolean;
}

// SERVIÇO (typology_group) — vários por grupo.
export type TypologyGroup = {
  id: number;
  category: TypologyCategory | '';
  code: string;
  name: string;
  reportType: ReportType | '';
  billingUnit: BillingUnit | '';
  priceType: TypologyPriceType;
  price: number;
  deadlineByProject: boolean;
  slaAlertDays: number;
  slaLimitDays: number;
  slaUseBusinessDay: boolean | null;
  typologies: Typology[]; // TIPOS
};

// GRUPO (criteria_group) — nome "GRUPO N"; guarda conceito de espaço +
// critérios de aceitação e agrupa vários serviços.
export type ServiceGroup = {
  id: number;
  activity: NoticeCriteriaGroupActivity;
  criteriaIds: number[];
  services: TypologyGroup[];
};

export type EditableTypologyGroupFields = Pick<
  TypologyGroup,
  | 'category'
  | 'code'
  | 'name'
  | 'reportType'
  | 'billingUnit'
  | 'priceType'
  | 'price'
  | 'deadlineByProject'
  | 'slaAlertDays'
  | 'slaLimitDays'
  | 'slaUseBusinessDay'
>;
